import MwsSyncStatusbar from './MwsSyncStatusbar'

export default MwsSyncStatusbar
